import styled from 'styled-components';
import { Table } from 'edenred-ui';

import { MassUploadDetailsStatus } from '@epi-models/pages/MassUploadDetails';

const getStatusBadgeColor = (status: MassUploadDetailsStatus, theme: any) => {
  switch (status) {
    case MassUploadDetailsStatus.Closed:
      return theme.positiveColor;
    case MassUploadDetailsStatus.ClosedWithFailures:
      return theme.warningColor;
  }
  return theme.gray25;
};

export const PageTitle = styled.h1`
  font-size: ${({ theme }) => theme.sizeExtraExtraLarge};
  font-weight: ${({ theme }) => theme.fontSemiBold};
  color: ${({ theme }) => theme.primaryFontColor};
`;

export const SummaryWrapper = styled.div`
  background: ${({ theme }) => theme.primaryBackgroundAltColor};
  border-radius: 8px;
  padding: 24px;
  display: grid;
  grid-template-columns: repeat(8, auto);
  grid-template-rows: auto auto;
  column-gap: 20px;
  row-gap: 8px;
  margin-bottom: 32px;
`;

export const SummaryBox = styled.div`
  display: grid;
  grid-row: span 2;
  grid-template-rows: subgrid;
`;

export const SummaryLabel = styled.span`
  font-size: ${({ theme }) => theme.sizeSmall};
  font-weight: ${({ theme }) => theme.fontSemiBold};
  color: ${({ theme }) => theme.primaryFontColor};
  word-wrap: break-word;
`;

export const SummaryValue = styled.span<{ isError?: boolean }>`
  font-size: ${({ theme }) => theme.sizeMedium};
  font-weight: ${({ theme }) => theme.fontRegularBold};
  color: ${({ theme, isError }) =>
    isError ? theme.warningColor : theme.primaryFontColor};
`;

export const StatusWrapper = styled.div`
  display: flex;
  align-items: center;
  gap: 8px;
`;

export const StatusBadge = styled.div<{ status: MassUploadDetailsStatus }>`
  display: flex;
  align-items: center;
  gap: 8px;
  &::before {
    content: '';
    width: 12px;
    height: 12px;
    border-radius: 50%;
    background-color: ${({ status, theme }) =>
      getStatusBadgeColor(status, theme)};
  }
`;

export const TableContainer = styled.div`
  background-color: ${({ theme }) => theme.primaryBackgroundColor};
  margin-top: 16px;
`;

export const StyledTable = styled(Table)`
  table-layout: fixed;
  width: 100%;
  border-collapse: collapse;
`;

export const TableHeaderCell = styled(Table.Cell)`
  font-weight: ${({ theme }) => theme.fontBold};
  color: ${({ theme }) => theme.primaryFontColor};
  border-bottom: 2px solid ${({ theme }) => theme.gray10};
  padding: 12px 16px;
`;

export const StyledRow = styled(Table.Row)<{ isError?: boolean }>`
  background-color: ${({ isError, theme }) =>
    isError ? theme.warningBackgroundColor : 'transparent'} !important;
  transition: background-color 0.2s ease-in-out;

  &:hover {
    background-color: ${({ isError, theme }) =>
      isError ? theme.warningBackgroundColor : theme.gray5} !important;
  }
`;

export const TableCell = styled(Table.Cell)<{
  width?: string;
  alignRight?: boolean;
}>`
  width: ${({ width }) => width || 'auto'};
  padding: 12px 16px;
  text-align: ${({ alignRight }) => (alignRight ? 'right' : 'left')};
  vertical-align: top;
  font-size: ${({ theme }) => theme.sizeSmall};
  color: ${({ theme }) => theme.primaryFontColor};

  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
`;

export const StatusIndicator = styled.div<{ isError?: boolean }>`
  display: flex;
  align-items: center;
  gap: 8px;
  &::before {
    content: '';
    width: 8px;
    height: 8px;
    border-radius: 50%;
    background-color: ${({ isError, theme }) =>
      isError ? theme.warningColor : theme.positiveColor};
  }
`;

export const ErrorContainer = styled.div`
  color: ${({ theme }) => theme.warningColor};
  font-size: ${({ theme }) => theme.sizeSmall};
  line-height: 1.5;
  ul {
    margin: 0;
    padding-left: 0;
    list-style: none;
  }
  li {
    margin-bottom: 2px;
  }
`;

export const BackIconWrapper = styled.div`
  cursor: pointer;
`;
